// extracted by mini-css-extract-plugin
export default {"amiibo--list":"AmiiboList_amiibo--list__6uHXP"};